<template>
  <div class="container">
    <b-modal
      :model-value="modCrearSubmenu"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog"
    >
        <div class="uniform-modal-body">
            <div class="password-policy-box mb-3">
                <div class="password-policy-title">{{ labels.infoTitle }}</div>
                <div class="password-policy-item">{{ labels.infoText }}</div>
            </div>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.name}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" :items="nombre" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.description}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" :items="descripcion" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.route}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="text" :items="ruta" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.orden}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <input type="number" :items="orden" class="form-control reset-input">
                </b-col>
            </b-row>
            <b-row class="d-flex align-items-center uniform-form-row">
                <b-col cols="12" md="4" class="text-left uniform-label-col">
                    <h5>{{labels.menu}}</h5> 
                </b-col>
                <b-col cols="12" md="8" class="text-left">
                    <select class="form-control reset-input" :items="menuSelected">
                        <option
                            v-for="menu in listaMenu"
                            :key="menu.id" 
                            :value="menu.id" 
                        >
                            {{ menu?.nombre }} 
                        </option>
                    </select>
                </b-col>
            </b-row>
            <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                <b-button class="mr-2 reset-btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
                <b-button class="reset-btn-primary" @click="guardarSubMenu">{{ labels.save }}</b-button>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import Menu from '../../../services/Menu'; 
import SubMenu from '../../../services/SubMenu'; 

export default {
    name:"CrearSubmenu",
    props:['modCrearSubmenu'],
    data: () => ({
        nombre:"",
        descripcion:"",
        ruta:"",
        menuSelected:"",
        listaMenu:[],
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title : "Crear submenu",
                    name : "Nombre:",
                    description : "Descripción:",
                    route : "Ruta:",
                    menu : "Menú:",
                    save : "Guardar",
                    close : "Cerrar",
                    orden : "Orden:",
                    infoTitle: "Datos del submenú",
                    infoText: "Completa la información y guarda el nuevo submenú."
                }
            }else{
                return {
                    title : "Create submenu",
                    name : "Name:",
                    description : "Description:",
                    route : "Route:",
                    menu : "Menu:",
                    save : "Save",
                    close : "Close",
                    orden : "Order:",
                    infoTitle: "Submenu information",
                    infoText: "Complete the information and save the new submenu."
                }
            }
        }
    },
    methods:{
        guardarSubMenu(){
            // console.log("guardarSubMenu") 
            let dataForm = {
                'nombre' : this.nombre, 
                'descripcion' : this.descripcion, 
                'ruta' : this.ruta, 
                'orden' : this.orden, 
                'menu' : this.menuSelected, 
                'idUser' : this.$store.state.userId, 
            }
            // console.log(dataForm) 

            if(this.nombre == ""){ 
                this.$toast.error('Diligenciar el campo nombre') 
            
            }else if(this.descripcion == ""){ 
                this.$toast.error('Diligenciar el campo descripcion') 

            }else if(this.ruta == ""){ 
                this.$toast.error('Diligenciar el campo ruta') 

            }else if(this.orden == ""){ 
                this.$toast.error('Diligenciar el campo orden') 

            }else if(this.menuSelected == ""){ 
                this.$toast.error('Diligenciar el campo menu') 

            }else{
                SubMenu.createSubmenu(dataForm) 
                .then((res) => { 
                    if(res.status == 200){ 
                        this.$toast.success(res.data.message) 
                        location.reload(); 
                    }
                })
                .catch((err) => { 
                    console.log(err) 
                })
            }
        },
        cierraModal(){
            this.$emit('cierraModal',false) 
        }
    },
    mounted(){
        Menu.getAllMenu() 
        .then((res) => { 
            // console.log(res.data) 
            this.listaMenu = res.data.listMenu 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>

<style>

</style>
